import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Paper, Button, Divider, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchBuildingList } from "../../services/api/building";
import BuildingTable from "./BuildingTable";
import PaginationManager from "../../components/newComp/Pagination";
import { showToast } from "../../store/slices/toastSlice";
import { setPage, setRowsPerPage } from "../../store/slices/paginationSlice";
import BuildingFilters from "./BuildingFilters";

const BuildingsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { page, rowsPerPage } = useSelector((state) => state.pagination);

  const [buildingList, setBuildingList] = useState([]);
  const [filteredBuildingList, setFilteredBuildingList] = useState([]);
  const [selectBuildings, setSelectBuildings] = useState([]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const buildingRes = await fetchBuildingList();
        setBuildingList(buildingRes.data);
        setFilteredBuildingList(buildingRes.data);
      } catch (error) {
        dispatch(showToast({ message: error.message, severity: "error" }));
      }
    };
    fetchInitialData();
  }, [dispatch]);

  useEffect(() => {
    if (selectBuildings.length > 0) {
      const selectedIds = selectBuildings.map((b) => b.id);
      const filtered = buildingList.filter((b) => selectedIds.includes(b.id));
      setFilteredBuildingList(filtered);
      dispatch(setPage(0));
    } else {
      setFilteredBuildingList(buildingList);
    }
  }, [selectBuildings, buildingList, dispatch]);

  const handleChangePage = (event, newPage) => dispatch(setPage(newPage));

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(parseInt(event.target.value, 10)));
    dispatch(setPage(0));
  };

  const currentPageData = filteredBuildingList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box
      sx={{ width: "100%", p: { xs: 2, md: 3 }, backgroundColor: "#f7f8fa" }}
    >
      {/* Filter Section */}
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          mb: 3,
          p: 2.5,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
      >
        <BuildingFilters
          buildingList={buildingList}
          selectBuildings={selectBuildings}
          setSelectBuildings={setSelectBuildings}
          handleExport={() => {}}
        />
      </Paper>

      {/* Top Action Bar */}
      {/* Top Bar: Title + Add Button */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "#333" }}>
            Buildings List
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#024ad7",
            minHeight: 40,
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            "&:hover": {
              backgroundColor: "#fec01f",
              color: "#000",
            },
          }}
          onClick={() =>
            navigate("/building", { state: { from: "/building-list" } })
          }
        >
          + Add New Building
        </Button>
      </Box>

      {/* Table Section */}
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            p: 2,
          }}
        >
          <BuildingTable rows={currentPageData} />
        </Box>
        <Divider />
        <PaginationManager
          count={filteredBuildingList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
};

export default BuildingsList;
